import { type Variants } from "motion/react";

export const animationVariants: Variants = {
  hidden: {
    opacity: 0,
    translateX: "-100%",
    translateY: "-100%",
  },
  opacity: {
    opacity: [0.1, 0.2, 0.5, 1],
  },
  heading: {
    translateX: 0,
    translateY: 0,
    transition: {
      bounce: 0,
    },
  },
  menuItems: {
    translateX: 0,
    translateY: 0,
    transition: {
      bounce: 0,
      staggerChildren: 0.15,
    },
  },
  footer: {
    translateX: 0,
    translateY: 0,
    transition: {
      bounce: 0,
      delay: 0.5,
    },
  },
};
